import { FC, useCallback } from 'react';
import { CrossIcon, PrintIcon } from 'src/components';
import { SText } from 'src/components/SText';
import { DocumentPrintPayload } from 'src/features/printer/printer.types';
import { $colors } from 'src/theme';
import { IdModel } from 'src/types';

type Props = {
  data: DocumentPrintPayload[];
  printerIsReady: boolean;
  onPrint: (doc: string, id:IdModel) => void;
  onCancelPrint?: (id:string) => void;
  keysPrefix:string;
};

export const TablePrintContent: FC<Props> = ({ data, onPrint, printerIsReady, onCancelPrint, keysPrefix }) => {
  const onPrintHandler = useCallback(
    (doc: string, id:IdModel) => () => {
      onPrint(doc, id);
    },
    [onPrint],
  );

  return (
    <div className="w-full overflow-x-auto md:w-2/3 m-auto">
      <table className="w-full">
        <thead>
          <tr className="text-xs tracking-wide text-left  text-primary font-semibold uppercase border-b border-gray-300">
            <th className="px-4 py-2">
              <SText label="printer.table-tracking-number" />
            </th>
            <th className="px-4 py-2">
              <SText label="printer.coli-number-inside" />
            </th>
            <th className="px-4 py-2">
              <SText label="printer.sender" />
            </th>
            <th className="px-4 py-2">
              <SText label="printer.receiver" classNames="" />
            </th>
            <th className="px-4 py-2">
              <SText label="printer.actions" />
            </th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {data.map((item) => {
            return (
              <tr className="text-gray-700  border-b border-gray-300" key={`${keysPrefix}-${item.id}`}>
                <td className="px-4 py-1  text-md">{item.meta.tracker}</td>
                <td className="px-4 py-1 text-md">{item.meta.countColis}</td>
                <td className="px-4 py-1">
                  <div className="text-gray-800 flex-row flex  py-1 items-center m-auto w-full justify-between ">
                    <div className="items-center justify-center text-md">
                      <div>{item.meta.senderName}</div>
                      <div>{item.meta.fromAgencyName}</div>
                    </div>
                  </div>
                </td>
                <td>
                  <div>{item.meta.receiverName}</div>
                  <div>{item.meta.toAgencyName}</div>
                </td>

                <td className="px-4 py-1 text-md">
                  <div className="flex flex-row justify-between">
                    {printerIsReady ? (
                      <button
                        className={`p5`}
                        onClick={onPrintHandler(item.doc ?? item.document, item.id ?? item.meta.tracker)}
                      >
                        <PrintIcon width={50}/>
                      </button>
                    ) : (
                      <SText label="printer.cant-print-printer-not-ready" classNames="text-sm text-red-500 my-1" />
                    )}
                    {onCancelPrint && (
                      <button className="p3" onClick={()=>{
                   
                          onCancelPrint(item.id);
                    }}>
                        <CrossIcon color={$colors.primary} />
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
